import { apiRequest } from '../backend/vue-axios/axios';
import utils from './utils';
import form from './form';
import permissions from './permissions';

let crud;

export default crud = {
  request: (variables => new Promise((resolve, reject) => {
    apiRequest({
      module: variables.module,
      service: variables.service,
      pathparam: variables.pathparam,
      params: variables.params,
    })
      .then((response) => {
        resolve(utils.verify(response.data));
      })
      .catch(() => {
        reject(form.error(variables));
      });
  })),
  get: {
    one: (variables => new Promise((resolve) => {
      utils.reassign(variables, 'params', null);
      utils.reassign(variables, 'pathparam', { id: variables.id });
      crud.request(variables).then((response) => {
        resolve(response);
      });
    })),
    all: (variables => new Promise((resolve) => {
      crud.request(variables).then((response) => {
        if (response !== variables.condition) {
          resolve(response);
        } else {
          form.error(variables);
        }
      });
    })),
  },
  getStorage: (variables => new Promise((resolve) => {
    if (utils.storage(variables.items_name) !== null) {
      resolve(utils.storage(variables.items_name));
    } else {
      crud.request(variables).then((response) => {
        const filteredRes = permissions.apply(variables.service, response);
        sessionStorage[variables.items_name] = JSON.stringify(filteredRes);
        resolve(filteredRes);
      });
    }
  })),
  post: (variables => new Promise((resolve) => {
    crud.request(variables).then((response) => {
      resolve(response);
    });
  })),
  update: ((variables, reset) => {
    utils.reassign(variables, 'pathparam', { id: variables.params.id });
    crud.request(variables).then(() => {
      form.success(variables, reset);
    });
  }),
};
